import { render, staticRenderFns } from "./TrekLink.vue?vue&type=template&id=39896f5c&"
import script from "./TrekLink.vue?vue&type=script&lang=js&"
export * from "./TrekLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports